import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

interface TextRowType {
  label: string;
  prefix?: ReactNode;
  suffix?: ReactNode;
  value?: any;
  size?: "xs" | "sm" | "md" | "lg";
  largeCol?: boolean;
}

export const TextRow = ({ label, size, value, largeCol }: TextRowType) => {
  const { t } = useTranslation();

  return (
    <div className="row gy-1">
      <div className={largeCol ? "col-lg-5" : "col-lg-3"}>
        <Text weight="semibold" color="subtitle1" size={size ? size : "sm"}>
          {t(`${label}.LABEL`)}:
        </Text>
      </div>
      <div className="col-lg-7">
        <Text size={size} color="subtitle1">
          {value}
        </Text>
      </div>
    </div>
  );
};
